module.exports = __webpack_public_path__ + "img/ArrowUpRight.baf5b507.svg";